// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"JobList_dropdown__3ZWtJ","fieldTitle":"JobList_fieldTitle__2AKF3","jobList":"JobList_jobList__14vVI","fields":"JobList_fields__3Rp1v","root":"JobList_root__1viB6"};